module.exports = __webpack_public_path__ + "packs/media/images/check-1380d44f18913e79a375738e8ba0b3f6.svg";